import React from "react";
import { Spin } from "antd";

function SplashPage() {
  return (
    <div className="min-h-screen min-w-full flex justify-center items-center">
      <Spin size="large" />
    </div>
  )
}

export default SplashPage;